import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {


  private readonly messageSubject = new BehaviorSubject<string>('');
  private readonly messageSubjectGrid = new BehaviorSubject<string>('');
  private readonly ShowKWH = new BehaviorSubject<boolean>(false);

  // exposed observable (read-only outside)
  public message$: Observable<string> = this.messageSubject.asObservable();
  public messageGrid$: Observable<string> = this.messageSubjectGrid.asObservable();
  public ShowKWH$: Observable<boolean> = this.ShowKWH.asObservable()
  // sender method 
  setMessage(value: string,value2:string =''): void {
    this.messageSubject.next(value);
    this.messageSubjectGrid.next(value2)
  }
  showkwh(value:boolean){
    this.ShowKWH.next(value)
  }
  public customizer: string = '';
  public margin: number = 0;
  public config = {
    settings: {
      layout_type: 'ltr',
      layout_version: 'light-only',
      sidebar_type: 'compact-wrapper',
      icon: "stroke-svg",
    },
    color: {
      primary_color: '#155785',
      secondary_color: '#FE6A49',
    },
  };

  constructor() {
    if (this.config.settings.layout_type == 'box-layout') {
      document.body.classList.add('box-layout');
    }
    document
      .getElementsByTagName('html')[0]
      .setAttribute('dir', this.config.settings.layout_type);

    document.documentElement.style.setProperty(
      '--theme-deafult',
      this.config.color.primary_color
    );
    document.documentElement.style.setProperty(
      '--theme-secondary',
      this.config.color.secondary_color
    );
  }
}
